import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: { padding: 20 },
  row: { flexDirection: 'row', marginBottom: 0 },
  text: { fontSize: 7, display: 'inline-block' },
  textBold: { fontSize: 9, fontWeight: 'bold' },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw', height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>{children}</PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>{content}</PDFText>
);

export const PhysiotherapyBookingReportPdf = ({ data }) => {
  const user = JSON.parse(localStorage.getItem('user'));

  function formatDate(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const grandTotal = (data || []).reduce((total, row) => total + (Number(row.net_amt) || 0), 0);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Physiotherapy Booking Report">
          <PDFPage style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1 }}
            />

            {/* Table Header */}
            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '5%' }}   content="Sr." />
              <Text style={{ ...styles.columnHeader, width: '8%' }}   content="Bill No" />
              <Text style={{ ...styles.columnHeader, width: '8%' }}   content="Bill Date" />
              <Text style={{ ...styles.columnHeader, width: '14%' }}  content="Patient Name" />
              <Text style={{ ...styles.columnHeader, width: '8%' }}   content="UHID" />
              <Text style={{ ...styles.columnHeader, width: '8%' }}   content="Mobile" />
              <Text style={{ ...styles.columnHeader, width: '8%' }}   content="Pay Mode" />
              <Text style={{ ...styles.columnHeader, width: '12%' }}  content="Doctor" />
              <Text style={{ ...styles.columnHeader, width: '10%' }}  content="Sponsor" />
              <Text style={{ ...styles.columnHeader, width: '6%' }}   content="Bill Amt" />
              <Text style={{ ...styles.columnHeader, width: '6%' }}   content="Dis Amt" />
              <Text style={{ ...styles.columnHeader, width: '6%' }}   content="Net Amt" />
              <Text style={{ ...styles.columnHeader, width: '6%' }}   content="Bal Amt" />
            </View>

            {/* Table Rows */}
            {data && data.length > 0 ? (
              data.map((row, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{ ...styles.columnContent, width: '5%' }}  content={index + 1} />
                  <Text style={{ ...styles.columnContent, width: '8%' }}  content={row.bill_no || '-'} />
                  <Text style={{ ...styles.columnContent, width: '8%' }}  content={formatDate(row.billing_date)} />
                  <Text style={{ ...styles.columnContent, width: '14%', textAlign: 'left' }} content={row.patientName || '-'} />
                  <Text style={{ ...styles.columnContent, width: '8%' }}  content={row.uhid || '-'} />
                  <Text style={{ ...styles.columnContent, width: '8%' }}  content={row.mobile || '-'} />
                  <Text style={{ ...styles.columnContent, width: '8%' }}  content={row.pay_mode || '-'} />
                  <Text style={{ ...styles.columnContent, width: '12%', textAlign: 'left' }} content={row.doctor || '-'} />
                  <Text style={{ ...styles.columnContent, width: '10%', textAlign: 'left' }} content={row.sponsor || '-'} />
                  <Text style={{ ...styles.columnContent, width: '6%' }}  content={row.total_amt || 0} />
                  <Text style={{ ...styles.columnContent, width: '6%' }}  content={row.disc_amt || 0} />
                  <Text style={{ ...styles.columnContent, width: '6%' }}  content={row.net_amt || 0} />
                  <Text style={{ ...styles.columnContent, width: '6%' }}  content={row.balance_amt || 0} />
                </View>
              ))
            ) : (
              <Text style={{ padding: 10 }} content="No records found" />
            )}

            {/* Grand Total */}
            <View style={{ ...styles.row, marginTop: 7 }}>
              <Text
                style={{ ...styles.columnContent, width: '120px', fontSize: 9, fontFamily: 'Roboto', color: 'red' }}
                content="GRAND TOTAL :"
              />
              <Text
                style={{ ...styles.columnContent, width: '60px', fontSize: 8, fontFamily: 'Roboto' }}
                content={grandTotal.toFixed(2)}
              />
            </View>
          </PDFPage>
        </Document>
      </PDFViewer>
    </div>
  );
};
